import React, { useState, useRef, useEffect } from "react"
import { Erroralert, Successalert } from "../../components/popups";
import Loadingspinner from "../../components/Loadingspinner";
import { Avatar, Box, Button, Switch, TextField } from "@mui/material";
import { AccessAlarm, AccessAlarmOutlined, EditNoteOutlined, FavoriteBorderOutlined, LockOutlined, NotificationsOutlined, PersonOutline, ShoppingCart, Star, UploadFile, Visibility } from "@mui/icons-material";
import { Changepasswordurl, Fetchmyordersurl, Updateprofilepicurl, Updateuserinfourl, base_url } from "../../utils/urls";
import axios from "axios";
import { base64tofile, checkimageextension, currencyseperator, getBase64 } from "../../utils/functions";
import { Cropper } from "react-cropper";
import 'cropperjs/dist/cropper.css';
import { useDispatch, useSelector } from "react-redux";
import { setFavorites } from "../../store/favorites";
import { removeFromStore } from "../../utils/fn";
import Product from "../Products/Product";
import icons from '../../utils/icons.json';
import { setRecentlyViewed } from "../../store/recentlyViewed";
import ProductSlider from "../Products/ProductSlider";
import fetch from "../../utils/fetch";


const Buyeraccount = () => {

    const { user, loggedIn } = useSelector((state) => state.user);


    const [moduleactive, setmoduleactive] = useState('myorders');




    return (
        <div className="accountswrap">
            <div className="settingspage">
                <div className="wrapsettings">
                    <div className="settingsnav">
                        <div onClick={() => setmoduleactive('myorders')} className={moduleactive === 'myorders' ? "settingsactivelink" : "settingsinactivelink"}>
                            <ShoppingCart />&nbsp;&nbsp;  My orders
                        </div>
                        <div onClick={() => setmoduleactive('pendingreviews')} className={moduleactive === 'pendingreviews' ? "settingsactivelink" : "settingsinactivelink"}>
                            <EditNoteOutlined />&nbsp;&nbsp;  Pending Reviews
                        </div>
                        <div onClick={() => setmoduleactive('recents')} className={moduleactive === 'recents' ? "settingsactivelink" : "settingsinactivelink"}>
                            <AccessAlarmOutlined />&nbsp;&nbsp; Recently viewed
                        </div>
                        <div onClick={() => setmoduleactive('saved')} className={moduleactive === 'saved' ? "settingsactivelink" : "settingsinactivelink"}>
                            <FavoriteBorderOutlined />&nbsp;&nbsp;  Saved items
                        </div>
                        <div onClick={() => setmoduleactive('profile')} className={moduleactive === 'profile' ? "settingsactivelink" : "settingsinactivelink"} >
                            <PersonOutline />&nbsp;&nbsp;  Profile Settings
                        </div>
                        <div onClick={() => setmoduleactive('password')} className={moduleactive === 'password' ? "settingsactivelink" : "settingsinactivelink"}>
                            <LockOutlined />&nbsp;&nbsp;  Password
                        </div>
                        <div onClick={() => setmoduleactive('notification')} className={moduleactive === 'notification' ? "settingsactivelink" : "settingsinactivelink"}>
                            <NotificationsOutlined />&nbsp;&nbsp;  Notifications
                        </div>
                    </div>
                    <div className="settingscontent">
                        {moduleactive === 'profile' && <Profilesettings />}
                        {moduleactive === 'password' && <Passwordsettings />}
                        {moduleactive === 'notification' && <Notificationsettings />}
                        {moduleactive === 'myorders' && <Myorders user={user} />}
                        {moduleactive === 'recents' && <Recentlyviewed />}
                        {moduleactive === 'saved' && <Saveditems />}

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Buyeraccount

//profile settings
const Profilesettings = () => {
    const { user, loggedIn } = useSelector((state) => state.user);

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const [loading, setloading] = useState(false)

    const [profileurl, setprofileurl] = useState(user?.profileurl);
    const [username, setusername] = useState(user?.LEDGER_NAME);
    const [email, setemail] = useState(user?.EMAIL_ADDRESS);
    const [phone, setphone] = useState(user?.CONTACT_PHONE);

    const [profilepic, setprofilepic] = useState('');


    const [profilepicname, setprofilepicname] = useState('');
    const [picturestringtocrop, setpicturestringtocrop] = useState('');
    const [temppicturestring, settemppicturestring] = useState('');

    const cropperRef = useRef(null);
    const onCrop = () => {
        const cropper = cropperRef.current?.cropper;
        settemppicturestring(cropper.getCroppedCanvas().toDataURL());
    };



    const saveuserdetails = (event) => {
        seterror(null)
        setloading(true)
        event.preventDefault();
        axios.post(Updateuserinfourl, {
            username: username,
            email: email,
            phone: phone,
        }).then(function (response) {
            setloading(false)
            if (!response.data.error) {
                setsuccess('Details updated successfully')
                setTimeout(() => {//navigate user after 2 seconds of display
                    // setsessionuser(response.data)
                    // axios.defaults.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + response.data?.token }
                    // window.location.reload();
                }, 2000);
            } else {
                seterror(response.data.message)
            }
        }).catch(function (error) {
            setloading(false)
            seterror("there was an error try again later")
        });

    }

    //upload image
    const uploadimage = () => {
        seterror()
        setloading(true)
        const formData = new FormData();
        formData.append(//append profile pic
            "profilepic",
            profilepic,
            profilepicname
        );
        formData.append('baseurl', base_url);
        const config = { headers: { 'content-type': 'multipart/form-data' } }
        axios.post(Updateprofilepicurl, formData, config).then(response => {
            setloading(false)
            if (!response.data.error) {
                setsuccess("profile pic updated")
                user.profileurl = response.data.profileurl
                // setsessionuser(user)
                // setTimeout(() => {
                //     setsuccess('')
                //     seterror('')
                //     window.location.reload();
                // }, 2000);
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });

    }


    //set profile pic url
    const onchangeprofilepic = (pic) => {
        if (pic) {
            if (!checkimageextension(pic.name)) {
                seterror("Unsupported Format")
                setTimeout(() => { seterror() }, 2000);
            } else {
                setprofilepicname(pic.name)
                getBase64(pic, (result) => {
                    setpicturestringtocrop(result)
                    // setprofileurl(result)
                })
            }
        }
    }
    //finish profile pic croppings
    const finishcropping = () => {
        setprofilepic(base64tofile(temppicturestring, profilepicname))
        setprofileurl(temppicturestring)
        setpicturestringtocrop()
        settemppicturestring()
    }



    return (
        <div>
            <div className="settingstitle">Account Details</div>
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            {loading && <Loadingspinner />}
            <div className="wrapimagechange">
                {!picturestringtocrop && <div>
                    <img className="imageavatar" src={profileurl || require('./../../assets/common/avatar.png')} alt="Profile" />
                    {profilepic && <Button onClick={() => uploadimage()} variant="text" startIcon={<UploadFile />}>upload</Button>}
                </div>}
                <div style={{ display: "flex", marginLeft: 20 }}>
                    <div>
                        {picturestringtocrop &&
                            <Cropper
                                src={picturestringtocrop}
                                style={{ height: 300, width: "100%" }}
                                aspectRatio={12 / 12}
                                guides={false}
                                crop={onCrop}
                                ref={cropperRef}
                            />
                        }
                        {picturestringtocrop && <Button sx={{ mt: 2, mb: 2 }} onClick={() => finishcropping()} variant="contained" >DONE</Button>}
                        <label htmlFor="file-input" style={{ display: 'inline-block' }}>
                            <input
                                id="file-input"
                                type="file"
                                accept="image/*" // Specify accepted file types if needed
                                style={{ display: 'none' }}
                                onChange={(e) => onchangeprofilepic(e.target.files[0])}
                            />
                            &nbsp;&nbsp; <Button variant="contained" component="span">
                                Upload New
                            </Button>
                        </label>
                    </div>
                    &nbsp;&nbsp;&nbsp;{!picturestringtocrop && <Button variant="outlined" disabled={!profileurl && true}>Delete avatar</Button>}
                </div>
            </div>
            <Box component="form" onSubmit={saveuserdetails} noValidate sx={{ mt: 1 }}>
                <div className="wrapprofile">
                    <div className="profileleft">
                        <div>Email</div>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            value={email}
                            onChange={(e) => setemail(e.target.value)}
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        /><br />
                        <div>Phone</div>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="phone"
                            value={phone}
                            onChange={(e) => setphone(e.target.value)}
                            label="Phone Number"
                            name="email"
                            autoComplete="tel"
                            autoFocus
                        />
                    </div>
                    <div className="profileright">
                        <div>Username</div>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            value={username}
                            onChange={(e) => setusername(e.target.value)}
                            id="username"
                            label="Full name"
                            name="username"
                            autoFocus
                        />
                    </div>
                </div>
                <br />
                <Button type="submit" variant="contained">Save Changes</Button>
            </Box>

            <br /> <br />
        </div>
    )
}

//password settings 
const Passwordsettings = () => {
    const { user, loggedIn } = useSelector((state) => state.user);

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const [loading, setloading] = useState(false)


    const email = user?.email;

    //reset password
    const resetpassword = (event) => {
        seterror(null)
        setloading(true)
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const newpassword = data.get('newpassword')
        const cnewpassword = data.get('cnewpassword');

        if (cnewpassword !== newpassword) {
            seterror('the two passwords do not match')
            setloading(false)
        } else {
            axios.post(Changepasswordurl, {
                email: email,
                password: newpassword
            }).then(function (response) {
                setloading(false)
                if (!response.data.error) {
                    setsuccess('Password changed successfully')
                    setTimeout(() => {//navigate user after 2 seconds of display
                        setsuccess('')
                        seterror('')
                    }, 2000);
                } else {
                    seterror(response.data.message)
                }
            }).catch(function (error) {
                setloading(false)
                seterror("there was an error try again later")
            });
        }
    }




    return (
        <div>
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            {loading && <Loadingspinner />}
            <div >Password settings </div>
            <Box component="form" onSubmit={resetpassword} noValidate sx={{ mt: 1 }}>
                <TextField margin="normal" type='password' required fullWidth id="newpassword" label="New password" name="newpassword" /><br />
                <TextField margin="normal" type='password' required fullWidth id="cnewpassword" label="Confirm password" name="cnewpassword" />
                <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }}>
                    Change password
                </Button>
            </Box>
        </div>
    )
}

//notification settings
const Notificationsettings = () => {

    const [notification, setnotification] = useState(true);

    return (
        <div>Mobile Notifications<br /><br />
            <div className={"wrapnotificationsdiv"}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <NotificationsOutlined />&nbsp;&nbsp;  Notifications
                </div>
                <Switch onClick={() => setnotification(!notification)} defaultChecked={notification} />
            </div>
        </div>
    )
}

//const my orders
const Myorders = ({ user }) => {
    const [loading, setloading] = useState(false);

    const [orders, setorders] = useState([]);

    // add-review 
    // item_code title comments rating customer

    useEffect(() => {
        fetchmyorders()
    }, []);

    //fetch my orders
    function fetchmyorders() {
        setloading(true)
        fetch
            .get('fetchOrders', { WEB_USER: user.LEDGER_NUMBER })
            .then((res) => {
                setloading(false)
                console.log(res)
                setorders(res)
            })
            .catch((err) => {
                dispatch(setAlert({ type: 'error', message: 'Error loading Orders!! ' + err.message }));
                setloading(false)
            });
    }


    return (
        <div>
            {loading && <Loadingspinner />}
            <div className="cartname">ORDERS</div>
            {orders?.length > 0 && orders.map((val, orderkey) => {
                const orderproducts = val.products
                
                return (
                    <div key={orderkey}>
                        {orderproducts?.map((product, key) => {
                            const productimages = JSON.parse(product.imageurls);

                            return (
                                <div key={key} className="wrapcartitemwhole">
                                    <div className="wrapcartitem" >
                                        <img src={productimages[0]} className="productcartimage" />
                                        <div className="productcartdiv">
                                            <div style={{ width: "60%" }}>
                                                <div className="productviewname">{product.name}</div>
                                                <div className="lefttext"><AccessAlarm />Order {val.orderstatus} </div>
                                                <div className="ratings"> <Star />&nbsp;<Star />&nbsp;<Star />&nbsp;<Star />&nbsp;<Star />&nbsp; (9 verified ratings)</div>
                                            </div>
                                            <div className="cartprice">KSH {currencyseperator(product.price)} </div>
                                        </div>
                                    </div>
                                    <div className="bottomitem">
                                        <Button variant="text" startIcon={<Visibility />}>DETAILS</Button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )
            })}

        </div>
    )
}

const Saveditems = () => {

    const dispatch = useDispatch();

    const favorites = useSelector(state => state.favorites.data);

    useEffect(() => {
        window.scroll({ top: 0, behavior: 'smooth' });
    }, []);

    function clearFavorites() {
        removeFromStore(constants.FAVORITES);
        dispatch(setFavorites([]));
    }

    return (
        <div>
            <div className='accountsections'>
                <section className='accounttitle'>
                    <h3>Favorite Items</h3>
                    {favorites.length > 0 && <button onClick={clearFavorites} className='accountlink-btn' type='button' dangerouslySetInnerHTML={{ __html: 'Clear All' + icons.trash }} />}
                </section>

                {favorites.length === 0 && <p style={{ padding: '10px 10px 300px' }}>You currently don't have any favorites items.</p>}
                <div className='products-view'>
                    {favorites.map((product, index) => (
                        <Product data={product} key={product.item_code} />
                    ))}
                </div>
            </div>
        </div>
    )
}

const Recentlyviewed = () => {

    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);

    function clearRecentlyViewed() {
        dispatch(setRecentlyViewed(null));
        removeFromStore(constants.RECENTLY_VIEWED);
        dispatch(setAlert({ type: 'success', message: 'Recently viewed cleared' }));
    }


    return (
        <div>
            <div className='accountsections'>
                <section className='accounttitle'>
                    <h3>Recently Viewed</h3>
                    {recentlyViewed && recentlyViewed.length > 0 && <button onClick={clearRecentlyViewed} className="link-btn" type="button" dangerouslySetInnerHTML={{ __html: 'Clear' + icons.trash }} />}
                </section>
                {!recentlyViewed && <p style={{ padding: '20px 10px' }}>Products you viewed recently will be displayed here.</p>}
                {recentlyViewed && recentlyViewed.length > 0 && <ProductSlider data={recentlyViewed} />}
            </div>
        </div>
    )
}